<template>
  <!-- 个人信息 -->
  <div class="person-info">
    <h3>
      <i></i>
      <span>个人信息</span>
      <div class="edit" @click="editInfo" v-if="!onEdit && hasFinished"><img src="../../assets/edit_icon.png"> 编辑</div>
    </h3>
    <div class="person-box">
      <section class="base-sec">
        <label class="tit">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>
        <div class="con">
          <el-input v-model="name" value="" v-if="!hasFinished || onEdit" @focus="nameFocus" maxlength="10" placeholder="姓名" show-word-limit></el-input>
          <div class="txt" v-if="!onEdit && hasFinished">{{name}}</div>
        </div>
        <span class="error" v-if="nameErr">请填写姓名</span>
      </section>
      <section class="base-sec">
        <label class="tit">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别：</label>
        <div class="con">
          <el-select v-model="sex" placeholder="请选择" v-if="!hasFinished || onEdit" @change="getSex">
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
          <div class="txt" v-if="!onEdit && hasFinished">{{sex}}</div>
        </div>
        <span class="error" v-if="sexErr">请选择性别</span>
      </section>
      <section class="base-sec">
        <label class="tit">手机号码：</label>
        <div class="con">
          <el-input v-model="phone" v-if="!hasFinished || onEdit" @input="phoneChange" placeholder="手机号码" maxlength="11" show-word-limit></el-input>
          <div class="txt" v-if="!onEdit && hasFinished">{{phone}}</div>
        </div>
        <span class="error" v-if="phoneErr">请填写正确手机号</span>
      </section>
      <section class="base-sec" v-if="!hasFinished || showCode">
        <label class="tit code-tit">&nbsp;</label>
        <div class="con code-con">
          <el-input v-model="code" @focus="codeFocus" style="border: none;" placeholder="短信验证码"></el-input>
          <div class="code" @click="getCode">{{codeText}}</div>
        </div>
        <span class="error" v-if="codeErr">请填写验证码</span>
      </section>
      <section class="base-sec">
        <label class="tit">出生年份：</label>
        <div class="con">
          <el-date-picker v-model="birthday" type="year" v-if="!hasFinished || onEdit" placeholder="选择年份" format="yyyy年" value-format="yyyy" @change="getBirth"></el-date-picker>
          <div class="txt" v-if="!onEdit && hasFinished">{{birthdayName}}年</div>
        </div>
        <span class="error" v-if="birthErr">请选择出生年份</span>
      </section>
      <section class="base-sec">
        <label class="tit">从教年份：</label>
        <div class="con">
          <el-date-picker v-model="teachday" type="year" v-if="!hasFinished || onEdit" placeholder="选择年份" format="yyyy年" value-format="yyyy" @change="getTeach"></el-date-picker>
          <div class="txt" v-if="!onEdit && hasFinished">{{teachdayName}}年</div>
        </div>
        <span class="error" v-if="teachErr">请选择从教年份</span>
      </section>
      <section class="extend-sec" v-if="prizeObjNameList.length > 0 || !hasFinished || onEdit">
        <label class="tit">竞赛获奖情况：</label>
        <div class="con">
          <Prize v-for="(prize, index) in prizeList" :key="index" :prizeDetail="prizeObjList[prize]" :myIndex="prize" :levelObj="levelObj" :hasFinished="hasFinished" :onEdit="onEdit" :gradeObj="gradeObj" :aliClient="aliClient" ref="prizes" @deletePrize="deletePrize" @prizeResult="prizeResult"></Prize>
        </div>
      </section>
      <section class="extend-sec" v-if="paperObjNameList.length > 0 || !hasFinished || onEdit">
        <label class="tit">论文发表情况：</label>
        <div class="con">
          <Paper v-for="(paper, index) in paperList" :key="index" :paperDetail="paperObjList[paper]" :myIndex="paper" :aliClient="aliClient" :hasFinished="hasFinished" :onEdit="onEdit" ref="papers" @deletePaper="deletePaper" @paperResult="paperResult"></Paper>
        </div>
      </section>
      <section class="btn" v-if="!hasFinished || onEdit">
        <label class="tit">&nbsp;</label>
        <div class="con">
          <el-button type="primary" @click="onSubmit">保存</el-button>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import api from '../../utils/api'
import Prize from './prize.vue'
import Paper from './paper.vue'
let OSS = require('ali-oss')
export default {
  props: ['personInfo'],
  components: {
    Prize,
    Paper
  },
  inject: ['reload'],
  data () {
    return {
      userId: '',
      hasFinished: false, // 是否已经完成编辑
      name: '',
      sex: '',
      phone: '',
      code: '',
      onCount: false,
      codeText: '获取验证码',
      timer: {},
      birthday: '',
      birthdayName: '',
      teachday: '',
      teachdayName: '',
      prizeList: [], // 获奖情况个数
      prizeObjList: [], // 获奖结果(本地展示)
      prizeObjNameList: [], // 获奖结果（提交）
      paperList: [], // 论文个数
      paperObjList: [], // 论文结果(提交)
      paperObjNameList: [], // 论文结果(本地显示)
      levelObj: {}, // 获奖级别下拉选项
      gradeObj: {}, // 获奖等级下拉选项
      aliClient: {},
      // 错误提示
      nameErr: false,
      sexErr: false,
      phoneErr: false,
      codeErr: false,
      birthErr: false,
      teachErr: false,
      // 编辑
      onEdit: false,
      editPhone: '', // 当前编辑手机号
      showCode: false // 是否显示验证码
    }
  },
  mounted () {
    if (this.personInfo) {
      let localPersonInfo = window.sessionStorage.getItem('localPersonInfo')
      if (localPersonInfo) {
        let info = JSON.parse(localPersonInfo)
        this.setPageData(info)
      } else {
        // console.log('有数据，没缓存')
        this.hasFinished = this.personInfo.finishStatus
        this.setPageData(this.personInfo)
      }
    }
    this.userId = window.sessionStorage.getItem('userId')
  },
  methods: {
    // 获取阿里云权限
    getAliClient () {
      let _this = this
      api.aliPost('GetSTSRequest', {
        userId: _this.userId,
        type: 'avatar',
        actions: 1,
        duration: 3600
      }, res => {
        // console.log(res)
        let d = res.body
        let client = new OSS({
          region: 'oss-cn-shenzhen', // 云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
          accessKeyId: d.accesskey,
          accessKeySecret: d.accessSecret,
          stsToken: d.token,
          bucket: 'fzimg'
        })
        _this.aliClient = client
      })
    },
    // 组装页面数据
    setPageData (dataObj) {
      this.hasFinished = dataObj.finishStatus
      this.name = dataObj.userName
      this.sex = dataObj.gender
      this.phone = dataObj.mobilePhone
      this.birthday = dataObj.birthdate
      this.birthdayName = dataObj.birthdate
      this.teachday = dataObj.teachDate
      this.teachdayName = dataObj.teachDate
      this.levelObj = dataObj.dicPrizeLevels
      this.gradeObj = dataObj.dicGrades
      this.prizeObjList = JSON.parse(JSON.stringify(dataObj.competePrizeInfos)) // 浅拷贝问题处理
      this.prizeObjNameList = JSON.parse(JSON.stringify(dataObj.competePrizeInfos))
      this.paperObjList = JSON.parse(JSON.stringify(dataObj.paperInfos))
      this.paperObjNameList = JSON.parse(JSON.stringify(dataObj.paperInfos))
      // 获奖个数
      if (dataObj.competePrizeInfos.length > 0) {
        for (let i = 0; i < dataObj.competePrizeInfos.length; i++) {
          this.prizeList.push(i)
        }
      } else {
        this.prizeList.push(0)
      }
      // 论文个数
      if (dataObj.paperInfos.length > 0) {
        for (let j = 0; j < dataObj.paperInfos.length; j++) {
          this.paperList.push(j)
        }
      } else {
        this.paperList.push(0)
      }
    },

    // 姓名
    nameFocus () {
      this.nameErr = false
    },
    // 性别
    getSex (val) {
      // console.log(val)
      this.sexErr = false
    },
    // 电话
    phoneChange () {
      // 编辑后，手机号与修改前手机号不一致
      if (this.onEdit && this.phone.length === 11 && this.editPhone !== this.phone) {
        this.showCode = true
      } else {
        this.showCode = false
      }
      this.phoneErr = false
    },
    // 验证码
    codeFocus () {
      this.codeErr = false
    },
    // 获取验证码
    getCode () {
      let _this = this
      let reg = /^1[2|3|4|5|6|7|8|9]\d{9}/
      if (_this.phone === '' || !reg.test(_this.phone)) {
        _this.phoneErr = true
        return false
      }
      if (!_this.onCount) {
        _this.onCount = true
        api.modPost('GetVerifyCodeRequest', {
          mobilePhone: _this.phone,
          'type': 2
        }, (res) => {
          _this.codeText = '60s'
          _this.setCount()
        })
      }
    },
    // 出生年份
    getBirth (val) {
      this.birthdayName = val
      this.birthErr = false
    },
    // 从教年份
    getTeach (val) {
      this.teachdayName = val
      this.teachErr = false
    },
    // 添加获奖情况
    addPrize () {
      let plen = this.prizeList.length
      this.prizeList.push(plen)
    },
    // 删除获奖情况
    deletePrize (num) {
      let index = this.prizeList.indexOf(num)
      if (index > -1) {
        this.prizeList.splice(index, 1)
      }
    },
    // 获奖情况结果
    prizeResult (prizeArr) {
      if (prizeArr !== 0) {
        // 数据提交
        this.prizeObjNameList.push(prizeArr[0])
        // 本地显示
        this.prizeObjList.push(prizeArr[1])
      }
    },
    // 添加论文情况
    addPaper () {
      let plen = this.paperList.length
      this.paperList.push(plen)
    },
    // 删除论文情况
    deletePaper (num) {
      let index = this.paperList.indexOf(num)
      if (index > -1) {
        this.paperList.splice(index, 1)
      }
    },
    // 论文情况结果
    paperResult (paperArr) {
      if (paperArr !== 0) {
        this.paperObjNameList.push(paperArr[0])
        this.paperObjList.push(paperArr[1])
      }
    },
    // 倒计时
    setCount () {
      let count = 60
      let _this = this
      _this.timer = setInterval(() => {
        count--
        _this.codeText = count + 's'
        if (count <= 0) {
          clearInterval(_this.timer)
          _this.codeText = '重新获取'
          _this.onCount = false
        }
      }, 1000)
    },
    // 数组去重
    distinct (arr) {
      let result = []
      let obj = []
      let str
      for (var i = 0; i < arr.length; i++) {
        str = JSON.stringify(arr[i])
        if (obj.indexOf(str) === -1) {
          result.push(arr[i])
          obj.push(str)
        }
      }
      return result
    },
    // 提交
    onSubmit () {
      let _this = this
      let prizes = _this.$refs.prizes
      let papers = _this.$refs.papers
      let prizeCheck = false // 获奖结果校验
      let paperCheck = false // 论文结果校验
      // 清除获奖和论文列表信息，防止重复提交
      _this.prizeObjList = []
      _this.prizeObjNameList = []
      _this.paperObjList = []
      _this.paperObjNameList = []
      // 重新组装获奖和论文列表信息
      for (let i = 0; i < prizes.length; i++) {
        if (prizes[i].prizeSubmit()) {
          prizeCheck = true
        } else {
          prizeCheck = false
        }
      }
      for (let j = 0; j < papers.length; j++) {
        if (papers[j].paperSubmit()) {
          paperCheck = true
        } else {
          paperCheck = false
        }
      }
      if (_this.name === '') {
        _this.nameErr = true
        _this.showToast('请填写姓名')
        return false
      }
      if (_this.sex === '') {
        _this.sexErr = true
        _this.showToast('请选择性别')
        return false
      }
      if (_this.phone === '') {
        _this.phoneErr = true
        _this.showToast('请填写正确手机号')
        return false
      }
      if ((!_this.hasFinished || _this.showCode) && _this.code === '') {
        _this.codeErr = true
        _this.showToast('请填写验证码')
        return false
      }
      if (_this.birthday === '') {
        _this.birthErr = true
        _this.showToast('请选择出生年份')
        return false
      }
      if (_this.teachday === '') {
        _this.teachErr = true
        _this.showToast('请选择从教年份')
        return false
      }

      if (!prizeCheck) {
        return false
      }
      if (!paperCheck) {
        return false
      }
      _this.submitInfo1()
    },
    submitInfo1 () {
      let _this = this
      let personalInfo = {
        userId: _this.userId,
        userName: _this.name,
        gender: _this.sex,
        mobilePhone: _this.phone,
        verifyCode: _this.code,
        birthdate: _this.birthday,
        teachDate: _this.teachday,
        competePrizeInfos: _this.prizeObjNameList,
        paperInfos: _this.paperObjNameList,
        finishStatus: false
      }
      console.log(personalInfo)
      api.post('SaveSZTeacherPersonalInfoRequest', {
        part: 1,
        personalInfo: personalInfo
      }, res => {
        // console.log(res)
        _this.$message({
          message: '个人信息保存成功',
          type: 'success'
        })
        // 奖项信息
        personalInfo.finishStatus = true
        delete personalInfo.userId
        personalInfo.competePrizeInfos = _this.distinct(_this.prizeObjList)
        personalInfo.paperInfos = _this.distinct(_this.paperObjList)
        personalInfo.dicPrizeLevels = _this.levelObj
        personalInfo.dicGrades = _this.gradeObj
        let localPersonInfo = personalInfo
        window.sessionStorage.setItem('localPersonInfo', JSON.stringify(localPersonInfo))
        _this.hasFinished = true
        clearInterval(_this.timer)
        _this.codeText = '获取验证码'
        _this.onCount = false
        if (!_this.onEdit) {
          _this.$emit('hasFinish', 0)
        } else {
          _this.onEdit = false
        }
        // 更新缓存用户信息
        let usrInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
        usrInfo.name = _this.name
        window.sessionStorage.setItem('userInfo', JSON.stringify(usrInfo))
        // 刷新
        _this.reload()
      })
    },
    // 编辑
    editInfo () {
      this.onEdit = true
      this.editPhone = this.phone
      // 清除验证码
      if (this.code !== '') {
        this.code = ''
      }
    },
    // toast
    showToast (msg) {
      this.$message({
        message: msg,
        type: 'error'
      })
    }
  },
  watch: {
    personInfo (val) {
      // console.log(val)
      this.setPageData(val)
      this.getAliClient()
    }
  }
}
</script>
<style scoped>
  .person-info h3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
  }

  .person-info h3 i {
    width: 2px;
    height: 16px;
    background: #FE793A;
    margin-right: 10px;
  }

  .person-info h3 span {
    flex: 1;
  }

  .person-info h3 .edit {
    color: #FE793A;
    font-size: 12px;
    cursor: pointer;
  }

  .person-info h3 .edit img {
    width: 12px;
    height: 12px;
    vertical-align: middle;
    margin-bottom: 3px;
  }

  .person-box {
    margin-top: 24px;
  }

  .prize-box {
    background: #f4f4f4;
    padding: 17px 27px;
    border-top: 2px solid #fff;
  }

  .person-box section {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .person-box section .txt {
    font-size: 14px;
  }

  .person-box section.base-sec .tit {
    font-size: 14px;
    text-align: left;
    color: #333;
  }
  .person-box section.base-sec .tit.code-tit {
    width: 70px;
  }

  .person-box section.base-sec .con {
    margin-right: 10px;
  }

  .person-box section.base-sec .code-con {
    position: relative;
    width: 218px;
    height: 40px;
    margin-right: 10px;
  }

  .person-box section.base-sec .code-con .el-input >>> .el-input__inner {
    padding-right: 100px;
    box-sizing: border-box;
  }

  .person-box section.base-sec .con .el-input >>> .el-input__suffix {
    display: none;
  }

  .person-box section.base-sec .code-con .code {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 80px;
    font-size: 14px;
    color: #FE793A;
    text-align: center;
    cursor: pointer;
  }

  .person-box section.base-sec .error {
    color: #ff0000;
    font-size: 12px;
  }

  .person-box section.base-sec .el-input {
    width: 218px;
    margin-right: 10px;
  }

  .person-box section.base-sec .el-select {
    margin-right: 10px;
  }

  .person-box section.base-sec .el-date-editor {
    width: 217px;
  }

  .person-box section.extend-sec .tit {
    align-self: flex-start;
    font-size: 14px;
    color: #333;
  }

  .person-box section.extend-sec .con {
    width: 592px;
  }

  .person-box section.btn {
    margin-top: 40px;
  }

  .person-box section.btn .tit {
    width: 90px;
  }
</style>
